var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-page',{attrs:{"status":_vm.status,"title":_vm.title}},[_c('p',[_vm._v("\n\t\tSomething went wrong on our end. We've been notified, and we'll fix it as soon as possible.\n\t")]),_vm._v(" "),_c('btn',{attrs:{"primary":"","raised":""},on:{"click":_vm.goBack}},[_vm._v("Go back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }